module.exports = __webpack_public_path__ + "static/media/imdb-icon.c4e5cdee.png";